/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "../src/assets/js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../src/assets/js/main.js":
/*!********************************!*\
  !*** ../src/assets/js/main.js ***!
  \********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/handle-steps-logic */ "../src/assets/js/modules/handle-steps-logic.js");
/* harmony import */ var _modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/handle-change-gift-card-message */ "../src/assets/js/modules/handle-change-gift-card-message.js");
/* harmony import */ var _modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/handle-summary-toggle */ "../src/assets/js/modules/handle-summary-toggle.js");
/* harmony import */ var _modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_handle_shopify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/handle-shopify */ "../src/assets/js/modules/handle-shopify.js");
/* harmony import */ var _modules_handle_shopify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_shopify__WEBPACK_IMPORTED_MODULE_3__);





/***/ }),

/***/ "../src/assets/js/modules/handle-change-gift-card-message.js":
/*!*******************************************************************!*\
  !*** ../src/assets/js/modules/handle-change-gift-card-message.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var $giftMessageBtn = $('.js-gift-message');
var $giftMessageField = $('.js-message-field');
$giftMessageBtn.on('change', function () {
  var $this = $(this);
  var message = $this.data('message');
  $giftMessageField.val(message);
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-shopify.js":
/*!**************************************************!*\
  !*** ../src/assets/js/modules/handle-shopify.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {var product_slug;
var selling_plan_group;
var selling_plan_id;
var option_1;
var option_2;
var option_3;
var greeting_card;
var greeting_message;
var specific_requirements;
var card_delivery;
var card_name;
var card_email;
var card_from;
var date = new Date();
var year = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  year: "numeric"
});
var month = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  month: "2-digit"
});
var day = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  day: "2-digit"
});
var card_date = year + "-" + month + "-" + day;
var product;
var variants;
var variant_title;
var variant_key;
var variant_id;
var delivery_id;
var frequency = '1 Month';
var hash = window.location.hash;
var debug = false;

if (hash == "#_") {
  debug = true;
  console.log('DEBUG MODE ON');
}

;
$('.js-option, .js-select select').on('change selectric-change', function () {
  if ($(this).is("select")) {
    $elem = $(this).find(':selected');
  } else {
    $elem = $(this);
  }

  if ($elem.data("product-slug") !== undefined) {
    product_slug = $elem.data('product-slug');
  }

  if ($elem.data("selling-plan-group") !== undefined) {
    selling_plan_group = $elem.data('selling-plan-group');
  }

  if ($elem.data("selling-plan-id") !== undefined) {
    selling_plan_id = $elem.data('selling-plan-id');
  }

  if ($elem.data("option-1") !== undefined) {
    option_1 = $elem.data('option-1');
  }

  if ($elem.data("option-2") !== undefined) {
    option_2 = $elem.data('option-2');
  }

  if ($elem.data("option-3") !== undefined) {
    option_3 = $elem.data('option-3');
  }

  if ($elem.data("card-delivery") !== undefined) {
    card_delivery = $elem.data('card-delivery');
  }

  if ($elem.data("delivery-variant-id") !== undefined) {
    delivery_id = $elem.data('delivery-variant-id');
  }

  if ($elem.data("greeting-card") !== undefined) {
    greeting_card = $elem.data('greeting-card');
  }

  if ($elem.data("message") !== undefined) {
    greeting_message = $elem.data('message');
  }

  if (debug) {
    console.log('Selections:');
    console.log({
      product_slug: product_slug
    }, {
      selling_plan_group: selling_plan_group
    }, {
      selling_plan_id: selling_plan_id
    }, {
      option_1: option_1
    }, {
      option_2: option_2
    }, {
      option_3: option_3
    }, {
      delivery_id: delivery_id
    }, {
      greeting_card: greeting_card
    }, {
      greeting_message: greeting_message
    }, {
      specific_requirements: specific_requirements
    }, {
      card_delivery: card_delivery
    }, {
      card_name: card_name
    }, {
      card_email: card_email
    }, {
      card_from: card_from
    }, {
      card_date: card_date
    });
  }

  if ($elem.data("product-slug") !== undefined) {
    jQuery.getJSON(window.Shopify.routes.root + 'products/' + product_slug + '.js', function (product) {
      variants = product.variants;

      if (debug) {
        console.log('Product Data:');
        console.log(product);
      }
    });
  }
});
var $giftMessageBtn = $('.js-gift-message');
var $giftMessageField = $('.js-message-field');
$('.js-specific-requirements').on('change paste', function () {
  specific_requirements = $(this).val();

  if (debug) {
    console.log('Specific Requirements: ' + specific_requirements);
  }
});
$('.js-message-field').on('change paste', function () {
  greeting_message = $(this).val();

  if (debug) {
    console.log('Greeting Message: ' + greeting_message);
  }
});
$('.js-card-name').on('change paste', function () {
  card_name = $(this).val();

  if (debug) {
    console.log('Card Name: ' + card_name);
  }
});
$('.js-card-email').on('change paste', function () {
  card_email = $(this).val();

  if (debug) {
    console.log('Card Email: ' + card_email);
  }
});
$('.js-card-from').on('change paste', function () {
  card_from = $(this).val();

  if (debug) {
    console.log('Card From: ' + card_from);
  }
});
$('.js-card-date').on('change paste', function () {
  card_date = $(this).val();

  if (debug) {
    console.log('Card Date: ' + card_date);
  }
});
$('.js-select-form button[type="submit"]').on('click', function (event) {
  event.preventDefault();

  if (option_1 !== 0 && option_2 !== 0 && option_3 !== 0) {
    variant_title = option_1 + ' / ' + option_2 + ' / ' + option_3;
  } else if (option_1 !== 0 && option_2 !== 0) {
    variant_title = option_1 + ' / ' + option_2;
  } else if (option_1 !== 0) {
    variant_title = option_1;
  } else {
    alert('No Selections Made');
  }

  if (debug) {
    console.log('Variant Title: ' + variant_title);
  }

  $.each(variants, function (key, value) {
    if (debug) {
      console.log(key + ' ' + value.title);
    }

    if (value.title == variant_title) {
      if (debug) {
        console.log('Variant Key: ' + key);
      }

      variant_key = key;
      return false;
    }
  });

  if (variant_key !== undefined) {
    variant_id = variants[variant_key].id;

    if (debug) {
      console.log('Variant ID: ' + variant_id);
    }
  } else {
    alert('Cannot Find Variant');
  }

  if (delivery_id !== undefined) {
    addProductsToCart(variant_id, delivery_id);
  } else {
    addSubToCart(variant_id, 1, selling_plan_id);
  }
});

function addSubToCart(variant_id, qty, selling_plan_id) {
  if (selling_plan_id == 1575256200) {
    frequency = '2 Months';
  }

  ;
  data = {
    "id": variant_id,
    "quantity": qty,
    "selling_plan": selling_plan_id,
    properties: {
      'Specific Requirements': specific_requirements,
      'Greeting Card': greeting_card,
      'Greeting Message': greeting_message,
      'Card Delivery': card_delivery,
      'Card Name': card_name,
      'Card Email': card_email,
      'Card From': card_from,
      '_Frequency': frequency
    }
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      $('.form__btn').addClass('loading');
      $('.form__btn').prop('disabled', true);
    },
    success: function success() {
      if (debug) {
        console.log('Added to Cart');
        console.log(data);
      }

      window.location.href = '/checkout';
    },
    error: function error(xhr) {
      alert("Error. Please try again");

      if (debug) {
        console.log(xhr.statusText + xhr.responseText);
      }

      $('.form__btn').removeClass('loading');
      $('.form__btn').prop('disabled', false);
    },
    complete: function complete() {}
  });
}

function addProductsToCart(variant_id, delivery_id) {
  if (card_delivery == 'Home Delivery') {
    card_date = null;
  }

  ;
  data = {
    items: [{
      id: variant_id,
      quantity: 1,
      properties: {
        'Specific Requirements': specific_requirements,
        'Greeting Card': greeting_card,
        'Greeting Message': greeting_message,
        'Card Delivery': card_delivery,
        'Card Name': card_name,
        'Card Email': card_email,
        'Card From': card_from,
        'Send Date': card_date
      }
    }, {
      id: delivery_id,
      quantity: 1
    }]
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      $('.form__btn').addClass('loading');
      $('.form__btn').prop('disabled', true);
    },
    success: function success() {
      if (debug) {
        console.log('Added to Cart');
        console.log(data);
      }

      window.location.href = '/checkout';
    },
    error: function error(xhr) {
      alert("Error. Please try again");

      if (debug) {
        console.log(xhr.statusText + xhr.responseText);
      }

      $('.form__btn').removeClass('loading');
      $('.form__btn').prop('disabled', false);
    },
    complete: function complete() {}
  });
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery"), __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-steps-logic.js":
/*!******************************************************!*\
  !*** ../src/assets/js/modules/handle-steps-logic.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var listObj = {};
var $selectSection = $('.js-select-section');
var $checkOption = $('.js-option');
var $price = $('.js-price');
var $select = $('.js-select select');
var $dateInput = $('.js-card-date');
var priceMultiply = 1;
var dateSet = 0;
$select.selectric({
  disableOnMobile: false,
  nativeOnMobile: false
});
$select.on('selectric-change', function (event, element, selectric) {
  var $element = $(element);
  var closestSelect = $element.closest('.js-select');
  var $selectedOption = $element.closest('.js-select').find('.selectric-items li.selected');
  var optionIndex = $selectedOption.index();
  var $currentOption = $selectedOption.closest('.js-select').find('select option').eq(optionIndex);
  var $this = $(this);
  var $currentSelectSection = $this.closest('.js-select-section');
  var $currentSelectForm = $this.closest('.js-select-form');
  var currentIndex = $currentSelectSection.index();
  var dataSection = $currentOption.data('open');
  var sectionToOpen = $(".".concat(dataSection));
  closestSelect.addClass('is-selected');
  var formFoot = $currentSelectForm.find('.form__foot');
  var formFootHeight = formFoot.outerHeight() / 2;
  setTimeout(function () {
    var scrollPostion = 0;
    var winHeight = $(window).outerHeight() / 2;

    if (sectionToOpen.length = 0) {
      return;
    }

    if (sectionToOpen.length = 1) {
      var sectionHeight = sectionToOpen.outerHeight() / 2;
      scrollPostion = sectionToOpen.offset().top + sectionHeight - winHeight + formFootHeight;
    } else {
      var _sectionHeight = sectionToOpen[0].outerHeight();

      scrollPostion = sectionToOpen.offset().top + _sectionHeight - winHeight + formFootHeight;
    }

    $('html, body').stop().animate({
      'scrollTop': scrollPostion
    }, 0);
  }, 400);
  var hasOptions = $currentSelectSection.is('.has-options');

  if (hasOptions) {
    var $selectSectionsNotMain = $('.js-select-section:not(.is-main):not(.has-options)');
    $selectSectionsNotMain.stop().slideUp().removeClass('is-selected is-visible');
    $selectSectionsNotMain.find('.js-option').prop('checked', false);
  }

  $currentSelectSection.addClass('is-selected');
  sectionToOpen.stop().slideDown().addClass('is-visible');
  validateForm($currentSelectSection);
  handleSummary();
  handleDate();
  var $currentSelectSectionRadioOptions = $currentSelectSection.find('.js-option');
  $currentSelectSectionRadioOptions.prop('checked', false);
  var selectedValue = $currentOption.html();
  var selectionText = "".concat(selectedValue, " ").concat($(element).data('select'));
  listObj[listData] = selectionText;
  createList(listObj);
  checkIfFormIsCompleted($currentSelectForm);
});
$checkOption.on('change', function () {
  var $this = $(this);
  var $currentSelectSection = $this.closest('.js-select-section');
  var $currentSelectForm = $this.closest('.js-select-form');
  var currentIndex = $currentSelectSection.index();
  var dataSection = $this.data('open');
  var sectionToOpen = $(".".concat(dataSection));
  var formFoot = $currentSelectForm.find('.form__foot');
  var formFootHeight = formFoot.outerHeight() / 2;

  if ($(this).data("price-multiply") !== undefined) {
    priceMultiply = $(this).data('price-multiply');
  }

  setTimeout(function () {
    var scrollPostion = 0;
    var winHeight = $(window).outerHeight() / 2;

    if (sectionToOpen.length = 0) {
      return;
    }

    if (sectionToOpen.length = 1) {
      var sectionHeight = sectionToOpen.outerHeight() / 2;
      scrollPostion = sectionToOpen.offset().top + sectionHeight - winHeight + formFootHeight;
    } else {
      var _sectionHeight2 = sectionToOpen[0].outerHeight();

      scrollPostion = sectionToOpen.offset().top + _sectionHeight2 - winHeight + formFootHeight;
    }

    $('html, body').stop().animate({
      'scrollTop': scrollPostion
    }, 500);
  }, 100);
  var hasOptions = $currentSelectSection.is('.has-options');
  var isMain = $currentSelectSection.is('.is-main');
  var isSecondary = $currentSelectSection.is('.is-secondary');

  if (hasOptions && isMain) {
    var $selectSectionsNotMain = $('.js-select-section:not(.is-main)');
    $selectSectionsNotMain.stop().slideUp().removeClass('is-selected is-visible');
    $selectSectionsNotMain.find('.js-option').prop('checked', false);
    $selectSectionsNotMain.find('.js-required-field').val('');
    handleResetSelect($selectSectionsNotMain);
  } else if (hasOptions && isSecondary) {
    var _$selectSectionsNotMain = $('.js-select-section:not(.is-main):not(.is-secondary)');

    _$selectSectionsNotMain.stop().slideUp().removeClass('is-selected is-visible');

    _$selectSectionsNotMain.find('.js-option').prop('checked', false);

    _$selectSectionsNotMain.find('.js-required-field').val('');

    handleResetSelect(_$selectSectionsNotMain);
  }

  $currentSelectSection.addClass('is-selected');
  sectionToOpen.stop().slideDown(300).addClass('is-visible');
  validateForm($currentSelectSection);
  handleResetSelect($currentSelectSection);
  handleSummary();
  handleDate();

  function handleResetSelect(section) {
    var $currentSelect = section.find('.js-select');
    var hasSelect = $currentSelect.length > 0;

    if (hasSelect) {
      $select.prop('selectedIndex', 0).selectric('refresh');
      $select.closest('.js-select').removeClass('is-selected');
    }
  }
});
var $requiredFields = $('.js-required-field');

if ($requiredFields.length > 0) {
  $requiredFields.on('keyup', function () {
    var $this = $(this);
    var validateType = $this.attr('type');
    var val = $this.val();
    var emailPattern = /^[0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]+([0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]*[-._+])*[0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]+@[0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]+([-.][0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]+)*([0-9a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]*[.])[a-zA-ZÐ“Â¤Ð“ÒÐ“Â¶]{2,6}$/;
    var emptyVal = val === "";
    var $currentSelectSection = $this.closest('.js-select-section');

    if (validateType === "email") {
      $currentSelectSection.toggleClass('is-selected', emailPattern.test(val));
      $this.closest('.form__controls').toggleClass('error', !emailPattern.test(val));
    } else {
      $currentSelectSection.toggleClass('is-selected', !emptyVal);
      $this.closest('.form__controls').toggleClass('error', emptyVal);
    }

    validateForm($currentSelectSection);
  });
}

var validateForm = function validateForm($currentSelectSection) {
  var $currentSelectForm = $currentSelectSection.closest('.js-select-form');
  var currentIndex = $currentSelectSection.index();
  var requiredFields = $('.js-select-section.is-visible.is-required');
  var requiredSelectedFields = $('.js-select-section.is-visible.is-required.is-selected');

  if (currentIndex === 0) {
    $currentSelectForm.addClass('show-foot');
  }

  var isLastVisible = !$('[data-last]').hasClass('is-visible');
  var allRequiredFieldSelected = requiredFields.length === requiredSelectedFields.length;
  $currentSelectForm.toggleClass('is-full', !isLastVisible);

  if (!isLastVisible && allRequiredFieldSelected) {
    $currentSelectForm.addClass('is-completed');
    $currentSelectForm.find('.form__btn').prop('disabled', false);
  } else {
    $currentSelectForm.removeClass('is-completed');
    $currentSelectForm.find('.form__btn').prop('disabled', true);
  }
};

var handleSummary = function handleSummary() {
  listObj = {};
  var price = 0;
  var selectionText = '';
  var dataPrice;
  $('.js-select-section.is-selected').each(function (index, section) {
    var listData = $(this).data('list');
    var selectOptions = $(this).find('.js-select .selectric-items li:not(.select__placeholder).selected');

    if (selectOptions.length > 0) {
      var _index = selectOptions.index();

      selectionText = $(this).find('.js-select select option').eq(_index).data('selection');
      dataPrice = parseInt($(this).find('.js-select select option').eq(_index).data('price'), 10) || 0;
    } else {
      selectionText = $(this).find('.js-option:checked').data('selection');
      dataPrice = parseInt($(this).find('.js-option:checked').data('price'), 10) || 0;
    }

    price += dataPrice;
    listObj[listData] = selectionText;
  });
  createList(listObj);
  var $price = $('.js-price');
  $price.closest('.price').toggleClass('is-set', price > 0);
  $price.text(price * priceMultiply / 100);
};

var createList = function createList(object) {
  var $selectionList = $('.js-selection-list');
  $selectionList.empty();

  for (var _i = 0, _Object$values = Object.values(object); _i < _Object$values.length; _i++) {
    value = _Object$values[_i];
    $selectionList.append("<li><span>\u2192</span> ".concat(value, "</li>"));
  }
};

var handleDate = function handleDate() {
  Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
  };

  if ($dateInput && $('.js-date-section').hasClass('is-visible') && dateSet != 1) {
    dateSet = 1;
    var date = new Date();
    var year = date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      year: "numeric"
    });
    var month = date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      month: "2-digit"
    });
    var day = date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      day: "2-digit"
    });
    var formattedDate = year + "-" + month + "-" + day;
    var plus30date = new Date().addDays(30);
    var plus30year = plus30date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      year: "numeric"
    });
    var plus30month = plus30date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      month: "2-digit"
    });
    var plus30day = plus30date.toLocaleString('en-US', {
      timeZone: 'Australia/Melbourne',
      day: "2-digit"
    });
    var plus30formattedDate = plus30year + "-" + plus30month + "-" + plus30day;
    $dateInput.val(formattedDate);
    $dateInput[0].min = formattedDate;
    $dateInput[0].max = plus30formattedDate;
  }
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-summary-toggle.js":
/*!*********************************************************!*\
  !*** ../src/assets/js/modules/handle-summary-toggle.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var $summary = $('.js-summary');
var $win = $(window);
$summary.on('click', '.summary__head', function (event) {
  if ($win.outerWidth() > 1023) {
    return;
  } else {
    $(this).closest('.js-summary').toggleClass('is-active').find('.summary__body').stop().slideToggle();
  }

  event.preventDefault();
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })

/******/ });